'use client';

import { useEffect } from 'react';

export function useAsyncEffect(func: () => Promise<void>, deps: Array<any>) {
  useEffect(() => {
    func().then().catch(console.error);
  }, deps);
}